export default {"src":"/_next/static/media/signup.742ccf63.svg","height":515,"width":529};